export default __webpack_public_path__ + "2f6cf5ff1fe8f7e1d771007e7e19aae4.svg";